var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    fill: "#FF9100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 7.0488 16.9511 3 12 3V21C16.9511 21 21 16.9511 21 12Z",
    fill: "#FF9100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.8555C15.7862 18.8555 18.8555 15.7862 18.8555 12C18.8555 8.21383 15.7862 5.14453 12 5.14453C8.21383 5.14453 5.14453 8.21383 5.14453 12C5.14453 15.7862 8.21383 18.8555 12 18.8555Z",
    fill: "#FABE2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8555 12C18.8555 8.22 15.78 5.14453 12 5.14453V18.8555C15.78 18.8555 18.8555 15.78 18.8555 12Z",
    fill: "#FABE2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5138 10.5333C16.4515 10.3422 16.2867 10.2032 16.0879 10.1744L13.5903 9.8113L12.4727 7.54794C12.3842 7.36769 12.1921 7.27759 12 7.27759C11.8079 7.27759 11.6158 7.36769 11.5273 7.54794L10.4097 9.8113L7.91206 10.1744C7.71329 10.2032 7.54848 10.3422 7.48618 10.5328C7.42437 10.7238 7.47588 10.9334 7.61956 11.0735L9.42716 12.8358L9.00075 15.3237C8.96675 15.5214 9.04814 15.7213 9.21035 15.8392C9.37418 15.9582 9.58982 15.9725 9.7655 15.8794L12 14.7052L14.2345 15.8793C14.4116 15.9731 14.6279 15.9581 14.7896 15.8391C14.9519 15.7212 15.0332 15.5214 14.9992 15.3237L14.5723 12.8358L16.3804 11.0735C16.5241 10.9334 16.5756 10.7238 16.5138 10.5333Z",
    fill: "#FF9100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7897 15.8392C14.9519 15.7213 15.0333 15.5214 14.9993 15.3237L14.5723 12.8358L16.3804 11.0735C16.5241 10.9334 16.5756 10.7238 16.5138 10.5333C16.4515 10.3422 16.2867 10.2032 16.0879 10.1744L13.5903 9.8113L12.4727 7.54794C12.3842 7.36769 12.1921 7.27759 12 7.27759V14.7052L14.2345 15.8793C14.4117 15.9731 14.6279 15.9582 14.7897 15.8392Z",
    fill: "#FF9100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold-icon.4579da124a4b07c579a7fc6da0e05ce8.svg";
export { ForwardRef as ReactComponent };